import { render, staticRenderFns } from "./VacationRequestSidebar.vue?vue&type=template&id=7dfcf0b6&scoped=true&"
import script from "./VacationRequestSidebar.vue?vue&type=script&lang=js&"
export * from "./VacationRequestSidebar.vue?vue&type=script&lang=js&"
import style0 from "./VacationRequestSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VacationRequestSidebar.vue?vue&type=style&index=1&id=7dfcf0b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfcf0b6",
  null
  
)

export default component.exports